import { styled } from '@mui/material';

import RichTextView from '../../../../../../../components/RichText/View';
import Tooltip, { tooltipClasses } from '../../../../../../../components/Tooltip';

export const OptionDetailsPopper = styled(Tooltip)(({ theme }) => ({
  filter: 'drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.5))',
  overflow: 'auto',
  [`& .${tooltipClasses.tooltip}`]: {
    ...theme.typography.paragraphMedium,
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    padding: theme.spacing(2),
    border: `0.5px solid ${theme.palette.grey[300]}`,
    borderRadius: theme.spacing(2),
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.white,
  },
}));

export const StyledRichTextView = styled(RichTextView)(({ theme }) => ({
  maxWidth: 440,
  maxHeight: 384,
}));
